export default __webpack_public_path__ + "static/media/ibm.2cd6597a.png";